import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VideoPlaylistData } from './videoPlaylistData';

const routes: Routes = [
  {
    path: 'vPlaylist',
    component: VideoPlaylistData,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VideoPlaylistDataRoutingModule {}
